import { ugcCreateValidator } from '@Pass-It-Down/passitdown-utils'

export default function ugcUpdateValidator(ugc) {
  if (!ugc.id) return { isValid: false, message: 'No id' }

  const v = ugcCreateValidator(ugc)
  return { isValid: v.isValid, message: v.messages[0]?.message }
}